import { getAuthHeadersWithTokenOnly } from '@discover-frontend/auth';
import { getAccountsApiBaseUrl } from '@discover-frontend/components';

import { TRIAL_USAGE_LOG_ENDPOINT } from './constants';

export type TrialUsageLogPayload = {
  feature: string;
  extra_info?: string;
};

export type TrialUsageLogResponse = {
  ok?: boolean;
  code?: string;
  message?: string;
};

export const postTrialUsageLog = async (
  body: TrialUsageLogPayload
): Promise<TrialUsageLogResponse> => {
  const url = `${getAccountsApiBaseUrl()}${TRIAL_USAGE_LOG_ENDPOINT}`;

  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...getAuthHeadersWithTokenOnly(),
  };

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  const data = (await response
    .json()
    .catch(() => ({}))) as TrialUsageLogResponse;

  if (!response.ok) {
    throw new Error(data.message || response.statusText);
  }

  return data;
};
